import { createI18n } from "vue-i18n"
import config from "../config"

// NOTE: import additional locales here, en locale is imported by default:
import "dayjs/locale/hu"
import "dayjs/locale/cs"

async function loadLanguages() {
  const langs: Record<string, any> = {}

  for (const lang of config.languages) {
    const [
      chargingPage,
      common,
      errors,
      landingPage,
      registrationPage,
      termsPage
    ] = await Promise.all([
      import(`./dictionaries/${lang}/chargingPage.json`).then((m) => m.default),
      import(`./dictionaries/${lang}/common.json`).then((m) => m.default),
      import(`./dictionaries/${lang}/errors.json`).then((m) => m.default),
      import(`./dictionaries/${lang}/landingPage.json`).then((m) => m.default),
      import(`./dictionaries/${lang}/registrationPage.json`).then(
        (m) => m.default
      ),
      import(`./dictionaries/${lang}/termsPage.json`).then((m) => m.default)
    ])

    langs[lang] = {
      ...chargingPage,
      ...common,
      ...errors,
      ...landingPage,
      ...registrationPage,
      ...termsPage
    }
  }

  return langs
}

export const setupI18n = async () => {
  const messages = await loadLanguages()

  return createI18n({
    legacy: false, // enables Composition API (useI18n)
    // globalInjection: true, // TODO: it still injects $t / $i18n for Option API components, after migrating everything to Composition API, remove it
    locale: config.defaultLanguage,
    messages
  })
}
